var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectiveInvoicesReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.638 37.483h-14.98a5.669 5.669 0 01-5.669-5.669V10.706a5.669 5.669 0 015.669-5.669h15.205a5.669 5.669 0 015.669 5.669v21.44"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.727,
    cy: 12.704,
    r: 1.444
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M22.487 15.732l-3.068-2.987 2.988-3.068M20.379 12.732l7.786-.026M14.105 22.92l2.422 2.112 2.329-2.03 2.372 2.068 2.502-2.182 2.498 2.178 2.634-2.297M14.105 29.743l2.422 2.112 2.329-2.03 2.372 2.069 2.502-2.182 2.498 2.178 2.634-2.297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectiveInvoicesReceived);
export default __webpack_public_path__ + "static/media/correctiveInvoicesReceived.30345a7fe5392adcadf68858ef9e1c9b.svg";
export { ForwardRef as ReactComponent };